import { setBaseUrl } from '@barboxx/api';

import {
    REACT_APP_API_HOST,
    REACT_APP_WEBSOCKET_HOST,
} from '../environments/environment';

// export const apiBaseUrl = 'https://dev.api.barboxx.io/v1';
// export const webSocketBaseUrl = 'https://dev.api.barboxx.io';
export const apiBaseUrl = REACT_APP_API_HOST;
export const webSocketBaseUrl = REACT_APP_WEBSOCKET_HOST;

setBaseUrl(apiBaseUrl);
